export const colors = [
  '#FAA41A',
  '#F4E534',
  '#10A07C'
];

export default function percentageToColor(percentage) {
  return colors[Math.floor((percentage / 10)/5)];
}
